import React, { useEffect, useState } from "react";
import { Col, List, RadioChangeEvent, Row } from "antd";
import { Radio } from "antd";
import styles from "./Rsvp.module.css";
import {
  DropDown,
  InputField,
  SubmitButton,
  TextComponent,
  TextHeader,
} from "../../../components";
import { BiCheck } from "react-icons/bi";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";
import Dropdown from "../../../components/dropdowns/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { EventPlanningMiddleware } from "../../../Store/Middlewares/EventPlanningMiddleware";
import {
  ClearRSVP,
  setRSVP,
} from "../../../Store/Actions/EventPlanningActions";
import { showAlert } from "../../../Store/Actions/GeneralActions";

function Rsvp() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const eventData = state?.data?.eventData;
  const Invitation = state?.data;
  const SeatingArrangement = useSelector(
    (state) => state.EventPlanningReducer.Seating
  );
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const Menu = useSelector((state) => state.EventPlanningReducer.Menu);
  const dispatch = useDispatch();
  const [table, setTable] = useState(
    RSVP?.seating?.table ? RSVP?.seating?.table : " "
  );
  const [meal, setMeal] = useState(
    RSVP?.seating?.meal ? RSVP?.seating?.meal : " "
  );
  const [selectedMeal, setselectedMeal] = useState(
    RSVP?.seating?.meal ? RSVP?.seating?.meal : []
  );
  console.log("table", RSVP);

  useEffect(() => {
    // if (RSVP?.event_id != Invitation?.eventData?.id) {
    //   dispatch(ClearRSVP());
    // }

    dispatch(
      EventPlanningMiddleware.eventMenus({ id: Invitation?.eventData?.id })
    );
    dispatch(
      EventPlanningMiddleware.eventTables({
        id: Invitation?.eventData?.id,
        name: "",
      })
    );
  }, []);

  const next = () => {
    if (!table?.id || selectedMeal?.length == 0) {
      dispatch(
        showAlert({
          type: "Error",
          title: "Seating & Meal",
          message: "Please select table and meal.!",
          status: 400,
        })
      );
    } else {
      let data = {
        ...RSVP,
        event_id: Invitation?.eventData.id,
        invitation: Invitation,
        seating: {
          table_id: table?.id,
          table: table,
          meal: selectedMeal,
        },
      };
      dispatch(setRSVP(data));
      navigate("/events/rsvp/rsvpstory", {
        state: { headrTitle: "RSVP", eventData: eventData },
      });
      // navigation.navigate('Story')
    }
  };
  // console.log("stateeeeee", state?.data);
  return (
    <div>
      <TextHeader text={"2. Select Seating & Meal"} />
      <div className={styles.containerHeader}>
        <div className={styles.textHeader}>
          <TextComponent
            text={"Seating Arrangements"}
            textClass={styles.headerText}
          />
          {/* <TextComponent text={"Arrangements "} textClass={styles.headerText} /> */}
        </div>
        <div>
          <div className={styles.dropdownContainer}>
            {/* <InputField styles={styles.mainInput} placeholder={"Venue Name"} /> */}
            <Dropdown
              placeholder={"Head Table 2"}
              stylesClass={styles.dropdown}
              selectedValue={RSVP?.seating?.table?.name}
              object={SeatingArrangement?.users.map((item) => ({
                ...item,
                id: item,
              }))}
              onChange={(e) => setTable(e.id)}
            />
          </div>
        </div>
      </div>
      <div className={styles.containerContent}>
        <div className={styles.textHeader}>
          <TextComponent text={"Meal  "} textClass={styles.headerText} />
        </div>
        <div className={styles.list}>
          <List
            className={styles.list}
            grid={{ xxl: 5, xl: 5, lg: 4, xs: 1, sm: 2, md: 3 }}
            itemLayout="horizontal"
            dataSource={Menu}
            renderItem={(item, i) => (
              <RenderItems
                item={item}
                i={i}
                selectedMeal={selectedMeal}
                setselectedMeal={setselectedMeal}
              />
            )}
          />
        </div>
      </div>
      <Row gutter={[8, 16]} className={styles.btnContainer}>
        <Col xs={24} sm={12} lg={6}>
          <SubmitButton
            title="Next"
            btnClass={styles.btnClass}
            onClick={next}
          />
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <SubmitButton
            title="Back"
            btnClass={styles.btnClass}
            outline={true}
            onClick={() =>
              navigate(
                state?.screenFrom == "Template"
                  ? "/events/GreetingTemplate"
                  : "/events/SelectedTemplate",
                {
                  state: { headrTitle: "RSVP" },
                }
              )
            }
          />
        </Col>
      </Row>
    </div>
  );
}
const RenderItems = ({ item, selectedMeal, setselectedMeal, i }) => {
  const [isSelected, setIsSelected] = useState(false);
  console.log("selectedMeal", selectedMeal);
  let meals = [...selectedMeal];
  const find = meals?.find((e) => e?.id == item?.id);

  return (
    <Row className={styles.listItem} key={item?.id}>
      <Col>
        <div
          onClick={() => {
            console.log("index", i);
            // const find = meals?.find((e) => e?.id == item?.id);
            if (!find) {
              meals.push(item);
              setselectedMeal(meals);
            } else {
              const filter = meals?.filter((e) => e?.id != item?.id);
              setselectedMeal(filter);
            }
            setIsSelected(!isSelected);
          }}
          className={find ? styles.slectedRadioButton : styles.radioButton}
        >
          {find ? <BiCheck className={styles.radioIcon} /> : null}
        </div>
      </Col>
      <Col>
        <TextComponent textClass={styles.radioText}>{item?.name}</TextComponent>
      </Col>
    </Row>
  );
};

export default Rsvp;
